import React, { useState, useEffect } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import DataTable from "react-data-table-component";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import { customTableStyles } from "../../assets/CustomTableStyles";
import DropdownWithCustomValuesModal from "../../components/DropdownWithCustomValuesModal";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import FullScreenLoader from "../../components/FullScreenLoader";

function DefineMeetingSlots() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");
  const userId = localStorage.getItem("userId");
  const roleId = localStorage.getItem("roleId");

  const [triggerRerender, setTriggerRerender] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    getValues,
    trigger,
    reset,
    setError,
  } = useForm({
    defaultValues: {
      id: 0,
      meetingDate: null,
      meetingSlotsDtos: [
        {
          id: 0,
          slotName: "",
          slotStartTime: "",
          slotEndTime: "",
        },
      ],
    },
  });

  const [centerId, setCenterId] = useState(savedCenterId || null);
  const [classSectionsData, setClassSectionsData] = useState([]);

  const fetchClassSectionsByCenterId = async () => {
    try {
      if (centerId) {
        const response = await get(
          `ClassSection/GetAllClassSectionByCenterId?centerId=${centerId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setClassSectionsData(response);
      } else {
        setClassSectionsData([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  useEffect(() => {
    fetchClassSectionsByCenterId();
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "meetingSlotsDtos",
  });

  const saveData = async (data) => {};

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Define Meeting Slots</h2>
      </div>

      <div className="row g-3">
        <div className="col-md-5">
          <div className="card h-100">
            <div className="card-body">
              <form className="row g-3" onSubmit={handleSubmit(saveData)}>
                <div className="col-md-6">
                  <label className="form-label">
                    Year Group - Section
                    <span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="campusActivityClassSectionDtos"
                    control={control}
                    rules={{
                      required: "This field is required.",
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={classSectionsData.map((classSection) => ({
                          value: classSection.id,
                          label: classSection.name,
                        }))}
                        onChange={(selectedOptions, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("campusActivityClassSectionDtos", []);
                          } else {
                            setValue(
                              "campusActivityClassSectionDtos",
                              selectedOptions
                            );
                            const mapped = selectedOptions.map((item) => ({
                              classSectionId: item.value,
                            }));
                            setValue("campusActivityClassSectionDtos", mapped);
                          }
                          trigger("campusActivityClassSectionDtos");
                        }}
                        isMulti
                        isClearable
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        value={
                          field.value?.map((item) => {
                            const match = classSectionsData.find(
                              (cs) => cs.id === item.classSectionId
                            );
                            return match
                              ? { value: match.id, label: match.name }
                              : null;
                          }) || []
                        }
                      />
                    )}
                  />
                  {errors.campusActivityClassSectionDtos && (
                    <small className="text-danger">
                      {errors.campusActivityClassSectionDtos.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Meeting Date
                    <span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("scheduleDateTime", {
                      required: "Start Date is required.",
                    })}
                    type="date"
                    className="form-control"
                  />
                  {errors.scheduleDateTime && (
                    <small className="text-danger">
                      {errors.scheduleDateTime.message}
                    </small>
                  )}
                </div>

                <div className="col-12">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">
                        Slot Name <span className="text-danger fs-9">*</span>
                      </label>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">
                        Start Time <span className="text-danger fs-9">*</span>
                      </label>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">
                        End Time <span className="text-danger fs-9">*</span>
                      </label>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Action</label>
                    </div>
                  </div>

                  {fields.map((field, index) => (
                    <div className="row g-3 mb-2" key={field.id}>
                      <div className="col-md-4">
                        <input
                          type="text"
                          className="form-control"
                          {...register(`meetingSlotsDtos.${index}.slotName`, {
                            required: "This field is required.",
                          })}
                        />
                        {errors?.meetingSlotsDtos?.[index]?.slotName && (
                          <small className="text-danger">
                            {errors.meetingSlotsDtos[index].slotName.message}
                          </small>
                        )}
                      </div>
                      <div className="col-md-3">
                        <input
                          type="time"
                          className="form-control"
                          {...register(
                            `meetingSlotsDtos.${index}.slotStartTime`,
                            {
                              required: "This field is required.",
                            }
                          )}
                        />
                        {errors?.meetingSlotsDtos?.[index]?.slotStartTime && (
                          <small className="text-danger">
                            {
                              errors.meetingSlotsDtos[index].slotStartTime
                                .message
                            }
                          </small>
                        )}
                      </div>
                      <div className="col-md-3">
                        <input
                          type="time"
                          className="form-control"
                          {...register(
                            `meetingSlotsDtos.${index}.slotEndTime`,
                            {
                              required: "This field is required.",
                              validate: (value) => {
                                const startTime = watch(
                                  `meetingSlotsDtos.${index}.slotStartTime`
                                );
                                if (!startTime) return true; // no start time yet entered
                                return (
                                  value >= startTime ||
                                  "Must be same or after Start Time."
                                );
                              },
                            }
                          )}
                        />
                        {errors?.meetingSlotsDtos?.[index]?.slotEndTime && (
                          <small className="text-danger">
                            {errors.meetingSlotsDtos[index].slotEndTime.message}
                          </small>
                        )}
                      </div>
                      <div className="col-md-2 d-flex align-items-start">
                        <button
                          className="btn btn-outline-primary py-1 px-2 me-1"
                          type="button"
                          onClick={() =>
                            append({
                              id: 0,
                              name: "",
                              slotStartTime: "",
                              slotEndTime: "",
                              activityId: 0,
                            })
                          }
                        >
                          <span className="fas fa-plus"></span>
                        </button>
                        {fields.length > 1 && (
                          <button
                            className="btn btn-outline-danger py-1 px-2"
                            type="button"
                            onClick={() => remove(index)}
                          >
                            <span className="fas fa-minus"></span>
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DefineMeetingSlots;
